import { Card, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useBreakpoint } from '../hooks/breakpoint';
import StyledContainer from './StyledContainer';
import ProfileComment from './ProfileComment';

const About = ({ Data, i18 }) => {
  const [loading, setLoading] = useState(true);
  const isMD = useBreakpoint();

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <React.Fragment>
      <div className="section" id="about">
        <StyledContainer>
          <Card
            loading={loading}
            style={{ cursor: 'default' }}
            hoverable
            variant="borderless"
            className="z-shadow"
          >
            <Row gutter={24}>
              <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                <ProfileComment Data={Data} i18={i18} isMD={isMD} />
              </Col>
            </Row>
          </Card>
        </StyledContainer>
      </div>
    </React.Fragment>
  );
};

export default About;
